var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanting(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "darkgrey",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.15039 2.5H8.4502C9.31337 2.5001 10.0174 3.157 10.0928 4H9.12012C6.684 4 4.70024 5.98382 4.7002 8.41992V17.5H4.15039C3.23653 17.5 2.5 16.7635 2.5 15.8496V4.15039C2.5 3.23653 3.23653 2.5 4.15039 2.5Z",
    fill: "darkgrey",
    stroke: "darkgrey"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5508 2.5H19.8506C20.7644 2.5001 21.5 3.2366 21.5 4.15039V15.8496C21.5 16.7634 20.7644 17.4999 19.8506 17.5H19.3701V8.41992C19.3701 5.98382 17.3863 4 14.9502 4H13.9082C13.9836 3.15696 14.6875 2.5 15.5508 2.5Z",
    fill: "darkgrey",
    stroke: "darkgrey"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12012 6.5H14.9502C16.014 6.5 16.8701 7.3561 16.8701 8.41992V19.5898C16.8701 20.6437 16.0138 21.5 14.96 21.5H13.25V19C13.25 18.3139 12.6861 17.75 12 17.75C11.3139 17.7501 10.75 18.3139 10.75 19V21.5H9.12012C8.05632 21.5 7.20024 20.6439 7.2002 19.5801V8.41992C7.20024 7.35613 8.05632 6.50004 9.12012 6.5ZM10 12.75C9.31395 12.7501 8.75 13.3139 8.75 14C8.75 14.6861 9.31395 15.2499 10 15.25H14C14.6861 15.25 15.25 14.6861 15.25 14C15.25 13.3139 14.6861 12.75 14 12.75H10ZM10 9.75C9.31395 9.75011 8.75 10.3139 8.75 11C8.75 11.6861 9.31395 12.2499 10 12.25H14C14.6861 12.25 15.25 11.6861 15.25 11C15.25 10.3139 14.6861 9.75 14 9.75H10Z",
    fill: "darkgrey",
    stroke: "darkgrey"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanting);
export default __webpack_public_path__ + "static/media/planting.4fdedf5b1caace9fd78b9812de03e428.svg";
export { ForwardRef as ReactComponent };